import React from 'react';
import s from './not-next-class-card.module.scss';
import { IconCalendar } from '@tabler/icons-react';
import classNames from 'classnames';
import { Button } from '@shared/ui/button/button';
import { getCDNPath } from '@utils/lib/getCDNpath';
import { useEditScheduleModal } from '@features/teacher/edit-schedule/model/use-edit-schedule-modal';

export const NotNextClassCard = ({ className, role = 'student' }) => {
	const { open: openEditScheduleModal } = useEditScheduleModal();

	const isStudent = role === 'student';

	return (
		<div className={classNames(className, s.nextClassCard)}>
			<img
				className={s.mascot}
				src={getCDNPath("images/character_no_lessons.webp")}
				alt=""
			/>
			<h3 className={s.title}>Занятий пока нет</h3>
			<div className={s.info}>
				{isStudent ? (
					<>
						<p>Выберите удобное время</p>
						<p>и продолжайте заниматься</p>
					</>
				) : (
					<>
						<p>Добавьте свободные часы</p>
						<p>для записи</p>
					</>
				)}
			</div>
			<Button
				className={s.button}
				label={isStudent ? 'Записаться' : 'Настроить расписание'}
				size="small"
				to={isStudent ? '/teachers' : undefined}
				onClick={isStudent ? undefined : () => openEditScheduleModal()}
				rightIcon={<IconCalendar size={20} color="#fff" />}
			/>
		</div>
	);
};
